import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import { IconButton } from '@mui/material';
import { Dropdown, DropdownProps } from 'antd';
import React, { memo } from 'react';
import type { MenuProps } from 'antd';
import styles from './AppTableActionMenu.module.scss';

type AppTableActionMenuProps = {
  items: MenuProps['items'];
  placement?: DropdownProps['placement'];
};

const AppTableActionMenu = ({
  items,
  placement = 'bottomRight',
}: AppTableActionMenuProps) => {
  return (
    <Dropdown
      menu={{ items }}
      placement={placement}
      trigger={['click']}
      overlayClassName={styles.appTableActionMenu}
    >
      <IconButton>
        <MoreVertOutlinedIcon className="dark:text-icon-dark" />
      </IconButton>
    </Dropdown>
  );
};

export default memo(AppTableActionMenu);
